export class AsignarGarantiaInquilinoRequest {
  
    public idGarantia : number=0;
    public id_PersonaInquilino : number=0;
}